var _path, _path2, _g, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38125 1.31566L1.25782 17.5657C0.843755 18.3969 1.44688 19.375 2.37657 19.375H18.6234C19.5531 19.375 20.1578 18.3969 19.7422 17.5657L11.6188 1.31566C11.1578 0.395349 9.84219 0.395349 9.38125 1.31566Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.5 1.09375C10.8016 1.09375 11.0641 1.25469 11.1984 1.525L19.3219 17.775C19.4453 18.0219 19.4328 18.3 19.2875 18.5344C19.1422 18.7703 18.9 18.9047 18.6234 18.9047H2.37657C2.1 18.9047 1.85782 18.7703 1.7125 18.5344C1.56719 18.2984 1.55469 18.0219 1.67813 17.775L9.80157 1.525C9.93594 1.25469 10.1984 1.09375 10.5 1.09375ZM10.5 0.625C10.0563 0.625 9.6125 0.854688 9.38125 1.31563L1.25782 17.5656C0.843755 18.3969 1.44688 19.375 2.37657 19.375H18.6234C19.5531 19.375 20.1578 18.3969 19.7422 17.5656L11.6188 1.31563C11.3875 0.854688 10.9438 0.625 10.5 0.625Z",
    fill: "#424242"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.5 5.3125C11.2234 5.3125 11.7953 5.88437 11.7469 6.55937L11.2125 14.0641C11.1875 14.4141 10.8766 14.6875 10.5 14.6875C10.1234 14.6875 9.81251 14.4141 9.78751 14.0641L9.25314 6.55937C9.2047 5.88437 9.77657 5.3125 10.5 5.3125ZM10.5 4.84375C10.0094 4.84375 9.54064 5.04375 9.21407 5.39375C8.90626 5.725 8.75314 6.15 8.78439 6.59219L9.31876 14.0969C9.36251 14.6906 9.88126 15.1562 10.5 15.1562C11.1188 15.1562 11.6375 14.6906 11.6797 14.0969L12.2141 6.59219C12.2453 6.15 12.0938 5.725 11.7844 5.39375C11.4594 5.04375 10.9906 4.84375 10.5 4.84375Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.5 15.3125C11.0172 15.3125 11.4375 15.7328 11.4375 16.25C11.4375 16.7672 11.0172 17.1875 10.5 17.1875C9.98281 17.1875 9.5625 16.7672 9.5625 16.25C9.5625 15.7328 9.98281 15.3125 10.5 15.3125ZM10.5 14.8438C9.725 14.8438 9.09375 15.475 9.09375 16.25C9.09375 17.025 9.725 17.6562 10.5 17.6562C11.275 17.6562 11.9062 17.025 11.9062 16.25C11.9062 15.475 11.275 14.8438 10.5 14.8438Z",
    fill: "#424242"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.3125C11.2234 5.3125 11.7953 5.88437 11.7469 6.55937L11.2125 14.0641C11.1875 14.4141 10.8765 14.6875 10.5 14.6875C10.1234 14.6875 9.81248 14.4141 9.78748 14.0641L9.25311 6.55937C9.20467 5.88437 9.77655 5.3125 10.5 5.3125Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.1875C11.0178 17.1875 11.4375 16.7678 11.4375 16.25C11.4375 15.7322 11.0178 15.3125 10.5 15.3125C9.98223 15.3125 9.5625 15.7322 9.5625 16.25C9.5625 16.7678 9.98223 17.1875 10.5 17.1875Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.5,
    y1: 5.78129,
    x2: 10.5,
    y2: 20.4438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#FFDC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#FFC107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 10.5,
    y1: 5.03906,
    x2: 10.5,
    y2: 17.3344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 10.5,
    y1: 5.03906,
    x2: 10.5,
    y2: 17.3344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.273b490a2c5f1d06a10c324c6500281e.svg";
export { ForwardRef as ReactComponent };